<template>
  <!-- 课件下载 -->
  <div class="download-box">
    <div class="download-title">
      课件下载
    </div>

    <div class="fileBox">
      <div @click="fileSave(item)" class="file-download" v-for="item of intoCloudData.wareList"
        :key='item.courseWareId'>
        <div class="file-download-lt">
          <img v-if="item.fileType=='ppt'" src="~@/assets/img/cloudClassCenter/P.png" alt="">
          <img v-if="item.fileType=='pdf'" src="~@/assets/img/cloudClassCenter/PDF.png" alt="">
          <img v-if="item.fileType=='doc'" src="~@/assets/img/cloudClassCenter/w.png" alt="">
          <img v-if="item.fileType=='xls'" src="~@/assets/img/cloudClassCenter/X.png" alt="">
          <img v-if="item.fileType=='zip'" src="~@/assets/img/cloudClassCenter/zip.png" alt="">
          <span>{{item.fileName}}</span>
        </div>
        <img src="~@/assets/img/cloudClassCenter/xiazai.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FileDownload",
  props: {
    //进入课程数据（进入课堂接口获取）--------------------------------------------
    intoCloudData: {}
  },

  methods: {
    //课件保存
    fileSave(item) {
      var link = document.createElement("a");
      //设置下载的文件名
      link.download = `${this.resourceData.name}.${
        item.fileSavePath
          .split("?")[0]
          .split(".")
          .reverse()[0]
      }`;
      link.style.display = "none";
      //设置下载路径
      link.href = item.fileSavePath;
      //触发点击
      document.body.appendChild(link);
      link.click();
      //移除节点
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="less" scoped>
.download-box {
  margin-left: 10px;
  padding: 16px 12px 0;
  width: 342px;
  height: 334px;

  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: 400;

  color: rgba(51, 51, 51, 1);
  background-color: #fff;

  .download-title {
    margin-bottom: 5px;
    border-bottom: 1px solid #ccc;
    height: 30px;

    font-size: 16px;
  }

  .fileBox {
    overflow: auto;

    height: 280px;

    .file-download {
      display: flex;

      position: relative;

      margin-top: 23px;
      height: 30px;

      cursor: pointer;

      justify-content: space-between;
      align-items: center;

      .file-download-lt {
        display: flex;

        justify-content: center;
        align-items: center;
      }

      img:nth-child(1) {
        margin-right: 11px;
        width: 24px;
        height: 29px;
      }

      span {
        overflow: hidden;

        width: 240px;

        font-size: 14px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      img:nth-child(3) {
        position: absolute;
        top: 6px;
        right: 14px;

        width: 13px;
        height: 16px;
      }
    }
  }
}
</style>